module.exports = __webpack_public_path__ + "images/cbbd86be326168873b83220df65151b4.png";